import { useState } from 'react';
import { SortingState } from '@tanstack/react-table';
import { MetaAdAccount, InstagramAccount } from '@frontend/gql/social/graphql';
import { EnrichedPostsData, LocalUpdate, EnrichedPost } from './usePostsData';
import { QueryVariables, ViewMode } from '../types';
import { Group, Project } from '../components/filters-form/types';

interface usePostsTabProps {
  projects: Project[];
  groups: Group[];
  queryVariables: QueryVariables;
  setSelectedColumns: (columns: string[]) => void;
  selectedColumns: string[];
  fetching: boolean;
  data: EnrichedPostsData | undefined;
  viewMode: ViewMode;
  setViewMode: (viewMode: ViewMode) => void;
  dates: {
    startDate: string;
    endDate: string;
  };
  updateLocalAssignment: (update: Omit<LocalUpdate, 'timestamp'>) => void;
  metaAdAccounts: MetaAdAccount[] | undefined;
  instagramAccounts?: InstagramAccount[] | undefined;
  postDetails?: EnrichedPost | null;
}

export const usePostsTab = ({
  projects,
  groups,
  queryVariables,
  fetching,
  data,
  setSelectedColumns,
  selectedColumns,
  viewMode,
  setViewMode,
  dates,
  updateLocalAssignment,
  metaAdAccounts,
  instagramAccounts,
  postDetails,
}: usePostsTabProps) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isPartialLoading, setIsPartialLoading] = useState(false);
  const [sorting, setSorting] = useState<SortingState>([
    {
      desc: true,
      id: 'total.engagements',
    },
  ]);

  const handleSortingChange = (sorting: SortingState) => {
    setCurrentPage(0);
    setSorting(sorting);
  };

  return {
    postsTabProps: {
      data,
      isLoading: fetching,
      isPartialLoading: fetching && isPartialLoading,
      setIsPartialLoading,
      currentPage,
      setCurrentPage,
      sorting,
      setSorting: handleSortingChange,
      selectedColumns,
      setSelectedColumns,
      queryVariables,
      viewMode,
      setViewMode,
      dates,
      projects,
      groups,
      updateLocalAssignment,
      metaAdAccounts,
      instagramAccounts,
      postDetails,
    },
  };
};
